import React, { useState, useEffect } from "react";
import Navbar from "../components/helpers/Navbar";
import Footer from "../components/helpers/Footer";
// import alt componentă tabel sau folosește direct <table>

const API_COTIZATII = "https://prdp-api.suport-949.workers.dev/api/cotizatii";
const API_MEMBRI = "https://prdp-api.suport-949.workers.dev/api/membri";

// Token hardcodat pentru autentificare Bearer
const TOKEN = "unwantedtok";
const AUTH_HEADER = {
  Authorization: `Bearer ${TOKEN}`,
};

const initialFormState = {
  id_membru: "",
  tip_cotizatie: "",
  suma: "",
  data_start: "",
  data_sfarsit: "",
  modalitate_plata: "",
  status: "",
  data_platii: "",
  comentarii: "",
};

const tipuriCotizatie = [
  { value: "", label: "-- Alege tip cotizație --" },
  { value: "simpatizant", label: "Simpatizant 1 RON" },
  { value: "cotizant-lunar", label: "Lunar 50 RON" },
  { value: "cotizant-anual", label: "Anual 200 RON" },
];

const modalitatiPlata = [
  { value: "", label: "-- Selectează metoda --" },
  { value: "card", label: "Card" },
  { value: "revolut", label: "Revolut" },
  { value: "paypal", label: "Paypal" },
];

const statusuri = [
  { value: "", label: "-- Selectează status --" },
  { value: "in asteptare", label: "În așteptare" },
  { value: "platit", label: "Plătit" },
];

const submeniu = [
  { key: "istoric", label: "Istoric" },
  { key: "adauga", label: "Înregistrează cotizație" },
];

function CotizatieAdmin() {
  const [tab, setTab] = useState("istoric");
  const [cotizatii, setCotizatii] = useState([]);
  const [membri, setMembri] = useState([]);
  const [form, setForm] = useState(initialFormState);
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState("");
  
  // pentru reload dupa sters/adaugat
  const fetchCotizatii = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_COTIZATII, { headers: AUTH_HEADER });
      setCotizatii(res.ok ? await res.json() : []);
    } catch {
      setCotizatii([]);
    }
    setLoading(false);
  };

  const fetchMembri = async () => {
    try {
      const res = await fetch(API_MEMBRI, { headers: AUTH_HEADER });
      setMembri(res.ok ? await res.json() : []);
    } catch {
      setMembri([]);
    }
  };

  useEffect(() => {
    fetchCotizatii();
    fetchMembri();
  }, []);

  // gestionare submit cotizatie noua
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const body = { ...form, suma: Number(form.suma) };
      const res = await fetch(API_COTIZATII, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...AUTH_HEADER },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error("Eroare la adăugare cotizație");
      setPopup("Cotizație înregistrată cu succes!");
      setForm(initialFormState);
      fetchCotizatii();
    } catch {
      setPopup("Eroare la înregistrarea cotizației.");
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Ești sigur?")) return;
    setLoading(true);
    try {
      await fetch(`${API_COTIZATII}/${id}`, { method: "DELETE", headers: AUTH_HEADER });
      setPopup("Cotizație ștearsă!");
      fetchCotizatii();
    } catch {
      setPopup("Eroare la ștergere cotizație.");
    }
    setLoading(false);
  };

  // calcul automat suma după tip cotizatie
  const handleTipCotizatieChange = (val) => {
    let suma = "";
    if (val === "simpatizant") suma = "1";
    if (val === "cotizant-lunar") suma = "50";
    if (val === "cotizant-anual") suma = "200";
    setForm(f => ({ ...f, tip_cotizatie: val, suma }));
  };

  return (
    <div>
      <Navbar />
      <div className="container py-5">
        <h2 className="mb-4 text-center text-primary-dark">
          Administrare cotizații
        </h2>
        <div className="d-flex gap-3 mb-4 justify-content-center">
          {submeniu.map(sub => (
            <button
              key={sub.key}
              className={"btn " + (tab === sub.key ? "btn-primary" : "btn-outline-primary")}
              style={{ minWidth: 180, borderRadius: 18, fontWeight: 600 }}
              onClick={() => setTab(sub.key)}
            >
              {sub.label}
            </button>
          ))}
        </div>

        {/* Tabs */}
        {tab === "istoric" ? (
          <>
            <h4 className="mb-3">Toate istoricul cotizațiilor membrilor</h4>
            {loading ? <div>Se încarcă...</div> : (
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nume membru</th>
                      <th>Tip cotizație</th>
                      <th>Suma</th>
                      <th>Perioadă</th>
                      <th>Plată</th>
                      <th>Status</th>
                      <th>Data plății</th>
                      <th>Acțiuni</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cotizatii.map((c, i) => (
                      <tr key={c.id}>
                        <td>{i+1}</td>
                        <td>{membri.find(m => m.id === c.id_membru)?.prenume} {membri.find(m => m.id === c.id_membru)?.nume}</td>
                        <td>{c.tip_cotizatie}</td>
                        <td>{c.suma} RON</td>
                        <td>{c.data_start} - {c.data_sfarsit}</td>
                        <td>{c.modalitate_plata}</td>
                        <td>{c.status}</td>
                        <td>{c.data_platii}</td>
                        <td><button className="btn btn-danger btn-sm" onClick={() => handleDelete(c.id)}>Șterge</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        ) : (
          <div style={{
            background: "#f8fafe", borderRadius: "18px", boxShadow: "0 2px 8px #e8eaf0",
            padding: 34, maxWidth: 520, margin: "0 auto"
          }}>
            <h4 style={{fontWeight: 700, color: "#114392", marginBottom: 6}}>Înregistrează cotizație</h4>
            <div style={{color: "#757575", marginBottom: 18, fontSize: 16}}>
              Completează formularul pentru a adăuga o cotizație nouă pentru orice membru.
            </div>
            <form onSubmit={handleFormSubmit} autoComplete="off">
              <div className="mb-3">
                <label>Membru:</label>
                <select
                  className="form-control"
                  value={form.id_membru}
                  onChange={e => setForm(f => ({ ...f, id_membru: e.target.value }))}
                  required
                >
                  <option value="">-- Alege membrul --</option>
                  {membri.map(membru => (
                    <option key={membru.id} value={membru.id}>
                      {membru.nume} {membru.prenume} ({membru.email})
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label>Tip cotizație:</label>
                <select
                  className="form-control"
                  value={form.tip_cotizatie}
                  onChange={e => handleTipCotizatieChange(e.target.value)}
                  required
                >
                  {tipuriCotizatie.map(opt => (
                    <option value={opt.value} key={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label>Suma:</label>
                <input
                  type="number"
                  className="form-control"
                  min={1}
                  value={form.suma}
                  onChange={e => setForm(f => ({ ...f, suma: e.target.value }))}
                  required
                />
              </div>
              <div className="mb-3">
                <label>Perioadă de la:</label>
                <input type="date" className="form-control" value={form.data_start}
                  onChange={e => setForm(f => ({ ...f, data_start: e.target.value }))} required
                />
              </div>
              <div className="mb-3">
                <label>Până la:</label>
                <input type="date" className="form-control" value={form.data_sfarsit}
                  onChange={e => setForm(f => ({ ...f, data_sfarsit: e.target.value }))} required
                />
              </div>
              <div className="mb-3">
                <label>Modalitate plată:</label>
                <select
                  className="form-control"
                  value={form.modalitate_plata}
                  onChange={e => setForm(f => ({ ...f, modalitate_plata: e.target.value }))}
                  required
                >
                  {modalitatiPlata.map(opt => (
                    <option value={opt.value} key={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label>Status:</label>
                <select
                  className="form-control"
                  value={form.status}
                  onChange={e => setForm(f => ({ ...f, status: e.target.value }))}
                  required
                >
                  {statusuri.map(opt => (
                    <option value={opt.value} key={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label>Dată plată (opțional):</label>
                <input type="date" className="form-control"
                  value={form.data_platii}
                  onChange={e => setForm(f => ({ ...f, data_platii: e.target.value }))}
                />
              </div>
              <div className="mb-3">
                <label>Comentarii (opțional):</label>
                <textarea
                  className="form-control"
                  value={form.comentarii}
                  onChange={e => setForm(f => ({ ...f, comentarii: e.target.value }))}
                  rows={2}
                />
              </div>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
                style={{ borderRadius: 17, fontWeight: 700, fontSize: 17, minWidth: 180 }}
              >
                {loading ? "Se salvează..." : "Înregistrează cotizație"}
              </button>
            </form>
          </div>
        )}
        {!!popup && (
          <div className="alert alert-info mt-4" style={{maxWidth:440,margin:"0 auto"}} onClick={() => setPopup("")}>
            {popup}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default CotizatieAdmin;
